(function () {
    function onDocumentReady(callback) {
        if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', callback);
        } else {
            callback();
        }
    }

    function parseNumericValue(rawValue) {
        if (rawValue === null || rawValue === undefined) return null;
        const text = String(rawValue).trim();
        if (text === '') return null;
        const cleanedText = text.replace(/[^0-9.\-]/g, '');
        if (cleanedText === '' || cleanedText === '.' || cleanedText === '-' || cleanedText === '-.')
            return null;
        const numeric = parseFloat(cleanedText);
        return Number.isFinite(numeric) ? numeric : null;
    }

    function toRoundedInt(numberValue) { return Math.round(Number(numberValue)); }

    function formatCurrency(numberValue) {
        const currency = window.shopCurrency || 'USD';
        try {
            return new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
                style: 'currency',
                currency: currency,
                maximumFractionDigits: 0
            }).format(toRoundedInt(numberValue));
        } catch (formatError) {
            return String(toRoundedInt(numberValue));
        }
    }

    function locateSliderForInput(minInputElement) {
        
        if (!minInputElement) return { slider: null, wrapper: document };
        const wrapperElement = minInputElement.closest('.price-filter-ui');
        if (wrapperElement) {
            const sliderCandidate = wrapperElement.querySelector('.price-slider');
            if (sliderCandidate) return { slider: sliderCandidate, wrapper: wrapperElement };
        }
        const priceRangeAncestor = minInputElement.closest('.price-range-wrapper');
        if (priceRangeAncestor) {
            const sliderCandidate2 = priceRangeAncestor.querySelector('.price-slider');
            if (sliderCandidate2) return { slider: sliderCandidate2, wrapper: priceRangeAncestor };
        }
        if (minInputElement.id) {
            const idBase = minInputElement.id.replace(/-GTE$/i, '');
            const guessedSlider = document.getElementById('price-slider-' + idBase);
            if (guessedSlider) return { slider: guessedSlider, wrapper: guessedSlider.closest('.price-filter-ui') || document };
        }
        const fallbackSlider = document.querySelector('.price-slider');
        return { slider: fallbackSlider, wrapper: fallbackSlider ? (fallbackSlider.closest('.price-filter-ui') || document) : document };
    }

    function debounce(fn, wait) {
        let timer = null;
        return function () {
            const callArgs = arguments;
            const callContext = this;
            clearTimeout(timer);
            timer = setTimeout(function () { fn.apply(callContext, callArgs); }, wait);
        };
    }

    function initializePriceSliders() {
        if (typeof noUiSlider === 'undefined') {
            console.warn('price-slider-init: noUiSlider not loaded.');
            return;
        }

        document.querySelectorAll('.price-input-min').forEach(function (minInputElement) {
            try {
               
                const wrapperCandidate =
                    minInputElement.closest('.price-filter-ui') ||
                    minInputElement.closest('.price-range-wrapper') ||
                    minInputElement.parentElement;

                if (wrapperCandidate && wrapperCandidate.__priceSliderInitialised) {
                    return; 
                }

                let maxInputElement = wrapperCandidate ? wrapperCandidate.querySelector('.price-input-max') : null;
                
                if (!maxInputElement) maxInputElement = document.querySelector('.price-input-max');
                if (!maxInputElement) { return; }

                const found = locateSliderForInput(minInputElement);
                const sliderElement = found.slider;
                const wrapperForThis = found.wrapper || (wrapperCandidate || document);
                if (!sliderElement) { return; }

                const declaredMinRaw = sliderElement.dataset.min ?? minInputElement.dataset.min ?? minInputElement.getAttribute('placeholder') ?? '0';
                const declaredMaxRaw = sliderElement.dataset.max ?? maxInputElement.dataset.max ?? maxInputElement.getAttribute('placeholder') ?? declaredMinRaw;
                let declaredMin = parseNumericValue(declaredMinRaw) ?? 0;
                let declaredMax = parseNumericValue(declaredMaxRaw) ?? declaredMin;

                const placeholderMax = parseNumericValue(maxInputElement.getAttribute('placeholder'));
                let inputMinNumeric = parseNumericValue(minInputElement.value);
                let inputMaxNumeric = parseNumericValue(maxInputElement.value);
                let startMin = (inputMinNumeric !== null) ? inputMinNumeric : declaredMin;
                let startMax = (inputMaxNumeric !== null) ? inputMaxNumeric : declaredMax;

                let likelyCents = false;
                if (declaredMax > 1000 && placeholderMax && declaredMax > (placeholderMax * 2)) {
                    likelyCents = true;
                }
                if (likelyCents) {
                    declaredMin = declaredMin / 100;
                    declaredMax = declaredMax / 100;
                    startMin = startMin / 100;
                    startMax = startMax / 100;
                    if (inputMinNumeric !== null) inputMinNumeric = inputMinNumeric / 100;
                    if (inputMaxNumeric !== null) inputMaxNumeric = inputMaxNumeric / 100;
                }

                if (typeof minInputElement.value === 'string') {
                    minInputElement.value = minInputElement.value.replace(/\.00$/, '');
                }
                if (typeof maxInputElement.value === 'string') {
                    maxInputElement.value = maxInputElement.value.replace(/\.00$/, '');
                }

                const minIsEmptyString = String(minInputElement.value).trim() === '';
                const maxIsEmptyString = String(maxInputElement.value).trim() === '';
                if (minIsEmptyString && maxIsEmptyString) {
                    startMin = declaredMin;
                    startMax = declaredMax;
                }

                if (startMin < declaredMin) startMin = declaredMin;
                if (startMax > declaredMax) startMax = declaredMax;
                if (startMin > startMax) { startMin = declaredMin; startMax = declaredMax; }

            
                if (!sliderElement.noUiSlider) {
                    noUiSlider.create(sliderElement, {
                        start: [toRoundedInt(startMin), toRoundedInt(startMax)],
                        connect: true,
                        step: 1,
                        range: { min: toRoundedInt(declaredMin), max: toRoundedInt(declaredMax) },
                        format: window.wNumb ? window.wNumb({ decimals: 0 }) : undefined
                    });
                } else {
                    try { sliderElement.noUiSlider.set([toRoundedInt(startMin), toRoundedInt(startMax)]); } catch (e) { /* ignore */ }
                }

                if (wrapperForThis) wrapperForThis.__priceSliderInitialised = true;

                const displayMinElement = wrapperForThis.querySelector('.price-min-display');
                const displayMaxElement = wrapperForThis.querySelector('.price-max-display');
                let programmaticUpdateGuard = false;

                if (sliderElement.noUiSlider && sliderElement.noUiSlider.off) {
                    try { sliderElement.noUiSlider.off('update'); sliderElement.noUiSlider.off('change'); } catch (e) { /* ignore */ }
                }

                sliderElement.noUiSlider.on('update', function (values) {
                    const valueLeft = parseNumericValue(values[0]) ?? declaredMin;
                    const valueRight = parseNumericValue(values[1]) ?? declaredMax;
                    if (displayMinElement) displayMinElement.textContent = formatCurrency(valueLeft);
                    if (displayMaxElement) displayMaxElement.textContent = formatCurrency(valueRight);
                });

                sliderElement.noUiSlider.on('change', function (values) {
                    let valueLeft = parseNumericValue(values[0]) ?? declaredMin;
                    let valueRight = parseNumericValue(values[1]) ?? declaredMax;
                    valueLeft = toRoundedInt(valueLeft); valueRight = toRoundedInt(valueRight);
                    programmaticUpdateGuard = true;
                    minInputElement.value = String(valueLeft);
                    maxInputElement.value = String(valueRight);

                    const evtInput = new Event('input', { bubbles: true });
                    const evtChange = new Event('change', { bubbles: true });
                    minInputElement.dispatchEvent(evtInput);
                    maxInputElement.dispatchEvent(evtInput);
                    minInputElement.dispatchEvent(evtChange);
                    maxInputElement.dispatchEvent(evtChange);

                    setTimeout(function () { programmaticUpdateGuard = false; }, 50);
                })


                function onInputTyping() {
                    if (programmaticUpdateGuard) return;

                    let typedMin = parseNumericValue(minInputElement.value);
                    let typedMax = parseNumericValue(maxInputElement.value);

                    const currentValues = sliderElement.noUiSlider.get();
                    const currentMin = parseNumericValue(currentValues[0]) ?? declaredMin;
                    const currentMax = parseNumericValue(currentValues[1]) ?? declaredMax;

                    const typingMinEmpty = String(minInputElement.value).trim() === '';
                    const typingMaxEmpty = String(maxInputElement.value).trim() === '';

                  
                    if (typingMinEmpty) {
                        typedMin = declaredMin;
                    } else {
                        if (typedMin === null) typedMin = currentMin;
                    }

                    if (typingMaxEmpty) {
                        typedMax = declaredMax;
                    } else {
                        if (typedMax === null) typedMax = currentMax;
                    }

                    if (likelyCents) {
                        if (typedMin !== null) typedMin = typedMin / 100;
                        if (typedMax !== null) typedMax = typedMax / 100;
                    }

                    if (typedMin < declaredMin) typedMin = declaredMin;
                    if (typedMax > declaredMax) typedMax = declaredMax;
                    if (typedMin > typedMax) typedMax = typedMin;

                    try {
                        sliderElement.noUiSlider.set([toRoundedInt(typedMin), toRoundedInt(typedMax)]);
                        if (displayMinElement) displayMinElement.textContent = formatCurrency(typedMin);
                        if (displayMaxElement) displayMaxElement.textContent = formatCurrency(typedMax);
                    } catch (e) {
                    }
                }

                const debouncedTypingHandler = debounce(onInputTyping, 150);

                minInputElement.addEventListener('input', debouncedTypingHandler);
                maxInputElement.addEventListener('input', debouncedTypingHandler);
                minInputElement.addEventListener('change', syncSliderFromInputs);
                maxInputElement.addEventListener('change', syncSliderFromInputs);

                const inputsMutationObserver = new MutationObserver(function (mutationsList) {
                    mutationsList.forEach(function (mutation) {
                        if (mutation.type === 'attributes' && (mutation.attributeName === 'value' || mutation.attributeName === 'placeholder')) {
                            syncSliderFromInputs();
                        }
                    });
                });
                try {
                    inputsMutationObserver.observe(minInputElement, { attributes: true, attributeFilter: ['value', 'placeholder'] });
                    inputsMutationObserver.observe(maxInputElement, { attributes: true, attributeFilter: ['value', 'placeholder'] });
                } catch (observeError) { }

            } catch (initialiseError) {
            }
        });

    }

    function observeFacetsContainer() {
        let facetsContainerElement = document.querySelector('.facets-container');
        if (!facetsContainerElement) facetsContainerElement = document.body;

        initializePriceSliders();

        const mutationObserver = new MutationObserver(function (mutations) {
            let shouldReinit = false;
            for (let i = 0; i < mutations.length; i++) {
                const mutation = mutations[i];
                if (mutation.type === 'childList' && (mutation.addedNodes.length || mutation.removedNodes.length)) { shouldReinit = true; break; }
                if (mutation.type === 'attributes' && (mutation.attributeName === 'class' || mutation.attributeName === 'style')) { shouldReinit = true; break; }
            }
            if (shouldReinit) {
                if (observeFacetsContainer._debounce) clearTimeout(observeFacetsContainer._debounce);
                observeFacetsContainer._debounce = setTimeout(function () {
                    initializePriceSliders();
                }, 60);
            }
        });

        try {
            mutationObserver.observe(facetsContainerElement, { childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'style'] });
        } catch (observeError) {
            document.addEventListener('click', function () { initializePriceSliders(); }, true);
        }
    }

    onDocumentReady(function () {
        observeFacetsContainer();
    });

})();
